import { useTranslation } from "react-i18next";

const BoundariesPopup = ({ handleBoundaries, message }) => {

    const { t } = useTranslation()

    return (<>
        <div className="modal fade show" style={{ display: "flex", alignItems: 'center', backgroundColor: "#00000055" }}>
            <div className="modal-dialog modal-xl" role="document" >
                <div className="modal-content p-3">
                    <div className="modal-header pt-0">

                        <h5 className="card-title fw-bold" id="exampleModalLongTitle">{message}</h5>
                        <button onClick={() => handleBoundaries()} type="button" className="close" style={{ marginLeft: "auto" }}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body mx-4">

                        <div className="row" >
                            <div className="col-12  " >
                                <div className="table-responsive pt-3">
                                    <table className="table table-striped table-bordered">
                                        <thead>
                                            <tr>
                                                <th className="w-6 text-center">{t('EncroachmentDashboard.SrNo')}</th>
                                                <th className="w-6 text-center">{t('EncroachmentDashboard.ConstructionBoundaries')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.ConstructionBoundariesName')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.Photo')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.Video')}</th>

                                            </tr>

                                        </thead>
                                        <tbody>

                                            <tr>
                                                <td className="py-1" align="center">1</td>
                                                <td className="text-center">{t('EncroachmentDashboard.East')}</td>
                                                <td className="text-center"></td>

                                                <td className="text-center">
                                                    <span className="view_button"
                                                    // onClick={() => handleBoundaries()}
                                                    >
                                                        {/* <i class="fa-solid fa-video"></i> */}
                                                        <i class="fa-regular fa-image"></i>
                                                    </span>
                                                </td>

                                                <td className="text-center">
                                                    <span className="view_button"
                                                    // onClick={() => handleBoundaries()}
                                                    >
                                                        {/* <i class="fa-solid fa-video"></i> */}
                                                        <i class="fa-solid fa-video"></i>
                                                    </span>
                                                </td>




                                            </tr>

                                            <tr>
                                                <td className="py-1" align="center">2</td>
                                                <td className="text-center">{t('EncroachmentDashboard.West')}</td>
                                                <td className="text-center"></td>

                                                <td className="text-center">
                                                    <span className="view_button"
                                                    // onClick={() => handleBoundaries()}
                                                    >
                                                        {/* <i class="fa-solid fa-video"></i> */}
                                                        <i class="fa-regular fa-image"></i>
                                                    </span>
                                                </td>

                                                <td className="text-center">
                                                    <span className="view_button"
                                                    // onClick={() => handleBoundaries()}
                                                    >
                                                        {/* <i class="fa-solid fa-video"></i> */}
                                                        <i class="fa-solid fa-video"></i>
                                                    </span>
                                                </td>




                                            </tr>

                                            <tr>
                                                <td className="py-1" align="center">3</td>
                                                <td className="text-center">{t('EncroachmentDashboard.South')}</td>
                                                <td className="text-center"></td>

                                                <td className="text-center">
                                                    <span className="view_button"
                                                    // onClick={() => handleBoundaries()}
                                                    >
                                                        {/* <i class="fa-solid fa-video"></i> */}
                                                        <i class="fa-regular fa-image"></i>
                                                    </span>
                                                </td>

                                                <td className="text-center">
                                                    <span className="view_button"
                                                    // onClick={() => handleBoundaries()}
                                                    >
                                                        {/* <i class="fa-solid fa-video"></i> */}
                                                        <i class="fa-solid fa-video"></i>
                                                    </span>
                                                </td>




                                            </tr>

                                            <tr>
                                                <td className="py-1" align="center">4</td>
                                                <td className="text-center">{t('EncroachmentDashboard.North')}</td>
                                                <td className="text-center"></td>

                                                <td className="text-center">
                                                    <span className="view_button"
                                                    // onClick={() => handleBoundaries()}
                                                    >
                                                        {/* <i class="fa-solid fa-video"></i> */}
                                                        <i class="fa-regular fa-image"></i>
                                                    </span>
                                                </td>

                                                <td className="text-center">
                                                    <span className="view_button"
                                                    // onClick={() => handleBoundaries()}
                                                    >
                                                        {/* <i class="fa-solid fa-video"></i> */}
                                                        <i class="fa-solid fa-video"></i>
                                                    </span>
                                                </td>




                                            </tr>

                                        </tbody>
                                    </table>
                                </div>

                            </div>


                        </div>
                    </div>

                    <div className="modal-footer">
                        <div className="row">
                            {/* <div className="col-12  d-flex justify-content-center">
                                <div className="form-group w-80 d-flex justify-content-between">
                                    <hr />
                                    <button
                                        type='button'
                                        onClick={() => handleBoundaries()}
                                        className="w-80 btn addbtn btn-success btn-brand btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u m-2 px-4" data-ktwizard-type="action-next">
                                        <i class="fa-solid fa-check pe-2"></i> Yes
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handleBoundaries}
                                        className="w-80  btn addbtn btn-danger btn-brand btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u m-2 px-4" data-ktwizard-type="action-next">
                                        <i className="fa-solid fa-xmark pe-2"></i> No
                                    </button>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </>);
}

export default BoundariesPopup;